
/**
 *  It can be argued that this should be in the design package. And it can
 *  be if that makes more sense in the future. For the moment, the only
 *  place I anticipate using these is in the component package.
 *  Pretty simple to move if the scope expans and we need a higher level
 *  palce to put this (design).
 */
export default {
  accept: 'Yes',
  addRule: 'Add Rule',
  am: 'am',
  apply: 'Apply',
  aria: {
      cancelEdit: 'Cancel Edit',
      close: 'Close',
      collapseRow: 'Row Collapsed',
      editRow: 'Row Edit',
      expandRow: 'Row Expanded',
      falseLabel: 'False',
      filterConstraint: 'Filter Constraint',
      filterOperator: 'Filter Operator',
      firstPageLabel: 'First Page',
      gridView: 'Grid View',
      hideFilterMenu: 'Hide Filter Menu',
      jumpToPageDropdownLabel: 'Jump to Page Dropdown',
      jumpToPageInputLabel: 'Jump to Page Input',
      lastPageLabel: 'Last Page',
      listLabel: 'Option List',
      listView: 'List View',
      moveAllToSource: 'Move All to Source',
      moveAllToTarget: 'Move All to Target',
      moveBottom: 'Move Bottom',
      moveDown: 'Move Down',
      moveTop: 'Move Top',
      moveToSource: 'Move to Source',
      moveToTarget: 'Move to Target',
      moveUp: 'Move Up',
      navigation: 'Navigation',
      next: 'Next',
      nextPageLabel: 'Next Page',
      nullLabel: 'Not Selected',
      pageLabel: 'Page {page}',
      previous: 'Previous',
      prevPageLabel: 'Previous Page',
      rotateLeft: 'Rotate Left',
      rotateRight: 'Rotate Right',
      rowsPerPageLabel: 'Rows per page',
      saveEdit: 'Save Edit',
      scrollTop: 'Scroll Top',
      selectAll: 'All items selected',
      selectRow: 'Row Selected',
      showFilterMenu: 'Show Filter Menu',
      slide: 'Slide',
      slideNumber: '{slideNumber}',
      star: '1 star',
      stars: '{star} stars',
      trueLabel: 'True',
      unselectAll: 'All items unselected',
      unselectRow: 'Row Unselected',
      zoomImage: 'Zoom Image',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
  },
  cancel: 'Cancel',
  choose: 'Choose',
  chooseDate: 'Choose Date',
  chooseMonth: 'Choose Month',
  chooseYear: 'Choose Year',
  clear: 'Clear',
  completed: 'Completed',
  contains: 'Contains',
  dateAfter: 'Date is after',
  dateBefore: 'Date is before',
  dateFormat: 'mm/dd/yy',
  dateIs: 'Date is',
  dateIsNot: 'Date is not',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  emptyFilterMessage: 'No results found',
  emptyMessage: 'No available options',
  emptySearchMessage: 'No results found',
  emptySelectionMessage: 'No selected item',
  endsWith: 'Ends with',
  equals: 'Equals',
  fileChosenMessage: '{0} files',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  firstDayOfWeek: 0,
  gt: 'greater than',
  gte: 'greater than or equal to',
  lt: 'less than',
  lte: 'less than or equal to',
  matchAll: 'Match All',
  matchAny: 'Match Any',
  medium: 'Medium',
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  nextDecade: 'Next Decade',
  nextHour: 'Next Hour',
  nextMinute: 'Next Minute',
  nextMonth: 'Next Month',
  nextSecond: 'Next Second',
  nextYear: 'Next Year',
  noFileChosenMessage: 'No file chosen',
  noFilter: 'No filter',
  notContains: 'Not contains',
  notEquals: 'Not equals',
  passwordPrompt: 'Enter a password',
  pending: 'Pending',
  pm: 'pm',
  prevDecade: 'Previous Decade',
  prevHour: 'Previous Hour',
  prevMinute: 'Previous Minute',
  prevMonth: 'Previous Month',
  prevSecond: 'Previous Second',
  prevYear: 'Previous Year',
  reject: 'No',
  removeRule: 'Remove Rule',
  searchMessage: '{0} results are available',
  selectionMessage: '{0} items selected',
  showMonthAfterYear: false,
  startsWith: 'Starts with',
  strong: 'Strong',
  today: 'Today',
  upload: 'Upload',
  weak: 'Weak',
  weekHeader: 'Wk',
};
